import { benefits } from "@/mocks/llkContent";
import { ScrollReveal } from "@/components/animations/ScrollReveal";
import { StaggerContainer, StaggerItem } from "@/components/animations/StaggerContainer";

export default function BenefitsSection() {
  return (
    <section className="relative py-20 md:py-28 bg-llk-cream">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <ScrollReveal>
            <p className="text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-llk-gold-dark mb-4">
              LLK BIO SOLUTIONS
            </p>
          </ScrollReveal>
          <ScrollReveal delay={0.1}>
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-llk-dark font-semibold">
              Tecnologia biológica aplicada onde a lavoura mais precisa
            </h2>
          </ScrollReveal>
        </div>

        <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6" staggerDelay={0.1} delayChildren={0.15}>
          {benefits.map((benefit) => (
            <StaggerItem key={benefit.title}>
              <div className="group relative p-6 md:p-8 rounded-2xl border border-llk-earth-pale/50 bg-white transition-all duration-500 hover:shadow-lg hover:-translate-y-1 h-full">
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 transition-colors ${
                    benefit.color === "gold"
                      ? "bg-llk-gold/10 group-hover:bg-llk-gold/20"
                      : "bg-llk-green-soft/10 group-hover:bg-llk-green-soft/20"
                  }`}
                >
                  <i
                    className={`${benefit.icon} text-xl ${
                      benefit.color === "gold" ? "text-llk-gold" : "text-llk-green-soft"
                    }`}
                  />
                </div>
                <h3 className="text-lg font-semibold text-llk-dark mb-2">{benefit.title}</h3>
                <p className="text-llk-dark/60 text-sm leading-relaxed">{benefit.description}</p>
                <div
                  className={`absolute bottom-0 left-0 right-0 h-1 rounded-b-2xl transition-opacity opacity-0 group-hover:opacity-100 ${
                    benefit.color === "gold"
                      ? "bg-gradient-to-r from-llk-gold to-llk-gold-light"
                      : "bg-gradient-to-r from-llk-green-soft to-llk-green"
                  }`}
                />
              </div>
            </StaggerItem>
          ))}
        </StaggerContainer>
      </div>
    </section>
  );
}